




































































































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType,
    pageDataType
} from "../types";

import {
    HOST
} from "../global";
import "swiper/dist/css/swiper.css";
import {
    swiper,
    swiperSlide
} from "vue-awesome-swiper";

@Component({
    name: "newsslider",
    components: {
        swiper,
        swiperSlide
    }
})
export default class NewsSlider extends Vue {
    @Prop() public compData!: string | null;
    @Getter("pageData") public pageData!: pageDataType;
    public HOST: string = HOST;
    public swiperOption: any = {
        spaceBetween: 30,
        centeredSlides: false,
        grabCursor: false,
        effect: "fade",
        speed: 1100,
        loop: true,
        direction: "horizontal",
        navigation: false,
        pagination: {
            el: '.swiper-pagination'
        },
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        // navigation: {
        //   nextEl: "#js-next1",
        //   prevEl: "#js-prev1"
        // }
    };

}
